<template>
  <div class="modal fade edit-image-modal" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <form @submit.prevent="submit">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">
                                &times;
                            </span>
            </button>

            <h4 class="modal-title">
              Edit Image
            </h4>
          </div>

          <loading-spinner v-if="loading"/>

          <div v-else class="modal-body">
            <text-form-group
                v-model="data.title"
                name="title"
                label="Title"
                :error="(errors.title || [])[0]"
                style="margin-right: 0; margin-left: 0"
            />

            <text-form-group
                v-model="data.credit"
                name="credit"
                label="Credit"
                :error="(errors.credit || [])[0]"
                style="margin-right: 0; margin-left: 0"
            />

            <text-form-group
                v-model="data.alt"
                name="alt"
                label="Alt"
                :error="(errors.alt || [])[0]"
                style="margin-right: 0; margin-left: 0"
            />

            <div>
              <cropper
                  class="cropper"
                  :src="'/images/' + image.id + '.' + image.attributes.extension"
                  :default-position="{left: image.attributes.crop_left || 0, top: image.attributes.crop_top || 0}"
                  :default-size="({imageSize}) => ({width: image.attributes.crop_width || imageSize.width, height: image.attributes.crop_height || imageSize.height})"
                  @change="change"
              />
            </div>

            <hr>

            <h4>
              Usage
            </h4>

            <p class="text-muted">
              This table shows the objects that use this image.
            </p>

            <table class="table table-striped table-condensed">
              <thead>
              <tr>
                <th class="col-xs-12">
                  Title
                </th>

                <th class="col-xs-12">
                  Type
                </th>
              </tr>
              </thead>

              <tbody v-if="usage.length">
              <tr v-for="row in usage">
                <td>
                  <a href="#" @click.prevent="navigate(row.attributes.url)">
                    {{ row.attributes.title }}
                  </a>
                </td>

                <td>
                  {{ row.attributes.usage_type | verboseUsageType }}
                </td>
              </tr>
              </tbody>

              <tbody v-else>
              <tr>
                <td colspan="2" class="text-center">
                  <i>
                    The image is not in use.
                  </i>
                </td>
              </tr>
              </tbody>
            </table>
          </div>

          <div class="modal-footer">
            <div class="pull-left">
              <button type="button" class="btn btn-danger" @click="destroy">
                <i class="fa fa-trash"></i> Delete
              </button>
            </div>

            <div class="pull-right">
              <button type="button" class="btn btn-default" data-dismiss="modal">
                Close
              </button>

              <button type="submit" class="btn btn-black">
                <i class="fa fa-save"></i> Save
              </button>
            </div>

            <div class="clearfix"></div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import {Cropper} from 'vue-advanced-cropper'
import Errors from '@/mixins/Errors'
import LoadingSpinner from '@/components/Layout/LoadingSpinner'
import TextFormGroup from '@/vendor/forms/FormGroups/Block/Text'
import 'vue-advanced-cropper/dist/style.css';

export default {
  components: {Cropper, LoadingSpinner, TextFormGroup},

  mixins: [Errors],

  props: {
    image: {
      required: true
    }
  },

  data() {
    return {
      data: {},
      usage: null,

      loading: true
    }
  },

  watch: {
    image() {
      this.data = {...this.image.attributes}

      this.load()
    }
  },

  mounted() {
    this.listenForClose()
  },

  methods: {
    listenForClose() {
      $(this.$el).on('hidden.bs.modal', this.reset)
    },

    load() {
      this.loading = true

      http.get('/api/v2/images/' + this.image.id + '/usage')
          .then(response => {
            this.usage = response.data.data

            this.loading = false
          })
    },

    submit() {
      http.put('/api/v2/images/' + this.image.id, {
        ...this.data
      })
          .then(response => {
            notify.success('The image was saved')

            this.$emit('updated', response.data.data)

            $(this.$el).modal('hide')
          })
          .catch(error => {
            if (error.response.status === 400) {
              return notify.error(error.response.data.message)
            }

            throw error
          })
          .catch(this.catchValidationErrors)
    },

    reset() {
      this.errors = {}

      this.data = {...this.image.attributes}
    },

    destroy() {
      http.delete('/api/v2/images/' + this.image.id).then(() => {
        notify.success('The image was deleted')

        this.$emit('deleted')

        $(this.$el).modal('hide')
      }).catch(error => {
        if (error.response.status === 400) {
          return notify.error(error.response.data.message)
        }

        throw error
      })
    },

    navigate(url) {
      $(this.$el).modal('hide')

      this.$router.push(url)
    },

    change({coordinates}) {
      this.data = {
        ...this.data,
        crop_top: coordinates.top,
        crop_left: coordinates.left,
        crop_width: coordinates.width,
        crop_height: coordinates.height,
      }
    }
  },

  filters: {
    verboseUsageType(usageType) {
      return {
        'users': 'User',
        'companies': 'Company',
        'publication-based-ad-formats': 'Publication Ad Format',
        'time-based-ad-formats': 'Time Ad Format',
        'marketing-site-blocks': 'Marketing Site Block',
        'content-articles': 'Content Article',
        'content-events': 'Content Event',
        'content-files': 'Content File',
        'content-bodies': 'Content Body',
        'portal-companies': 'Portal Company',
        'portal-company-logos': 'Portal Company (Logo)',
        'brands': 'Brand'
      }[usageType]
    }
  }
}
</script>
